import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function PaymentResult({ cancelled }) {
  const navigate = useNavigate();
  const [state, setState] = useState(cancelled ? "cancelled" : "polling");

  useEffect(() => {
    if (cancelled) return;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) { /* keep polling */ }
      if (++tries >= 10) { setState("timeout"); return; }
      setTimeout(tick, 2000);
    };
    tick();
  }, [cancelled]);

  const Icon = state === "paid" ? CheckCircle2 : state === "polling" ? Loader2 : XCircle;
  const color = state === "paid" ? "text-emerald-600" : state === "polling" ? "text-emerald-600" : "text-rose-600";
  const title = { paid: "Payment successful", polling: "Confirming your payment…", cancelled: "Payment cancelled",
    error: "Payment failed", timeout: "Still processing" }[state];
  const msg = { paid: "Thank you — your order has been paid.", polling: "Please wait a moment.",
    cancelled: "You cancelled the checkout. Your basket is still available.",
    error: "We couldn't confirm your payment. Please try again.",
    timeout: "Payment is taking longer than expected. Check back shortly." }[state];

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="payment-result-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm max-w-md w-full text-center">
        <Icon className={`h-12 w-12 mx-auto ${color} ${state === "polling" ? "animate-spin" : ""}`} />
        <h1 className="mt-4 text-2xl font-semibold text-slate-900" data-testid="payment-result-title">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{msg}</p>
        <button onClick={() => navigate("/portal/products")} className="mt-6 inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg px-5 py-2.5">
          Back to Products
        </button>
      </div>
    </div>
  );
}
